import axios from '../../axios'

/*
 * 用户管理模块
 */

// 保存
export const save = (data) => {
  return axios({
    url: '/car/save',
    method: 'post',
    data
  })
}
// 删除
export const batchDelete = (data) => {
  return axios({
    url: '/car/delete',
    method: 'post',
    data
  })
}
// 分页查询
export const findPage = (data) => {
  return axios({
    url: '/car/list',
    method: 'post',
    data
  })
}
// 详情
export const detailView = (data) => {
  return axios({
    url: '/car/detail',
    method: 'post',
    data
  })
}

// 备案
export const getCarAudit = (data) => {
  return axios({
    url: '/car/report/' + data,
    method: 'post'
  })
}
// 根据carnum获取对应的教练车信息
export const getCarData = (data) => {
  return axios({
    url: '/car/getCarData',
    method: 'post',
    data
  })
}
// 根据驾校ID获取教练车信息
export const getCarByInscode = (data) => {
  return axios({
    url: '/car/getCarByInscode',
    method: 'post',
    data
  })
}

// 根据驾校ID获取教练车信息
export const allList = (data) => {
  return axios({
    url: '/car/allList',
    method: 'post',
    data
  })
}


/**
 * 导入excel
 */
 export const importCar= (data) => {
  return axios({
    url: '/car/import',
    method: 'post',
    data
  })
}
/**
 * 导出 Excel
 * @param schoolId 驾校ID
 * @param licnum 车牌号码
 * @param carnum 车牌编号
 * @param plateColor 车牌颜色:1蓝色2:黄色3:黑色4:白色5:绿色9:其他
 * @param state 0-注销；1-未用；2:已备案 3-绑定,5-已注销 6- 已绑定
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=702570
 */
export const exportExcel = data => {
  return axios({
    url: '/car/exportExcel',
    method: 'post',
    responseType: 'blob',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/traincar/traincar.js